import { render, staticRenderFns } from "./base_upload.vue?vue&type=template&id=485d4731&scoped=true"
import script from "./base_upload.vue?vue&type=script&lang=js"
export * from "./base_upload.vue?vue&type=script&lang=js"
import style0 from "./base_upload.vue?vue&type=style&index=0&id=485d4731&prod&lang=less&scoped=true"
import style1 from "./base_upload.vue?vue&type=style&index=1&id=485d4731&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485d4731",
  null
  
)

export default component.exports